import { render, staticRenderFns } from "./CourseOrderDetail.vue?vue&type=template&id=69947462&scoped=true&"
import script from "./CourseOrderDetail.vue?vue&type=script&lang=js&"
export * from "./CourseOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseOrderDetail.vue?vue&type=style&index=0&id=69947462&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69947462",
  null
  
)

export default component.exports